// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2ild5","clinicsSelect":"TableHeading_clinicsSelect__3Z7jH"};